import { render, staticRenderFns } from "./TrendyolQuestionManagement.vue?vue&type=template&id=eff37370&scoped=true"
import script from "./TrendyolQuestionManagement.vue?vue&type=script&lang=js"
export * from "./TrendyolQuestionManagement.vue?vue&type=script&lang=js"
import style0 from "./TrendyolQuestionManagement.vue?vue&type=style&index=0&id=eff37370&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff37370",
  null
  
)

export default component.exports